import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { KeyboardKeyCodes } from 'common/common/constants/keyboard-key-codes';
import { slashCommands } from 'common/common/constants/slash-commands';
import { bcEnums } from 'common/common/constants/boldchat-enums';
import { BcFeatures } from 'common/common/constants/feature-enums';
import { MessageBusEvents } from 'common/common/constants/message-bus-events';
import { broadcastEvents } from 'common/common/constants/broadcast-events';
import { EditorMessages } from 'shared/components/editor-messages/editor-messages';
import { TextChatsService } from 'common/text-chats/text-chats.service';
import { TextChatMessagesService } from 'common/text-chat-messages/text-chat-messages.service';
import { TextChatMessagesStoreFactoryService } from 'common/text-chat-messages-store-factory/text-chat-messages-store-factory.service';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { WorkItemStateHandler } from 'shared/services/workitem-state-handler/workitem-state-handler.service';
import { CannedMessageRequest } from 'common/canned-messages/canned-message-request.interface';
import { TextChatUserStoreFactoryService } from 'common/text-chat-user-store-factory/text-chat-user-store-factory.service';
import { WrapupPanelService } from '../../shared/components/wrapup-panel/wrapup-panel.service';
import { RxEmitter } from 'common/rxjs/rx-emitter';
import { WrapUp } from 'common/api/models/wrap-up.model';
import { LaneManagerService } from 'shared/components/lane-buttons/shared/services/lane-manager/lane-manager.service';
import { throttle } from 'lodash';
import { MessageGroupService } from 'shared/services/message-group/message-group.service';
import { TinyMCEEditorComponent } from '../../../../../../shared/components/editor/editor.component';
import { TextChatItem } from '../../../../../../common/workitems/interfaces/text-chat.interface';
import { TextChat } from '../../../../../../common/xislivechat/models/text-chat';
import { BcAnalytics } from '../../../../../../common/analytics/analytics.service';
import { BcSettingsService } from '../../../../../../common/settings/settings.service';
import { BcAuth } from '../../../../../../common/auth/auth.service';
import { BcCannedMessagesRepo } from '../../../../../../common/canned-messages/canned-messages-repo';
import { WorkAreaManager } from '../../../../../../common/workitems/work-area-manager.service';
import { BcRestApi } from '../../../../../../common/api/rest-api';
import { TranslateService } from '@ngx-translate/core';
import { ClosingConfirmationService } from 'shared/components/confirmation-modal/confirmation-modal.service';
import { ConfirmationModalComponent } from 'shared/components/confirmation-modal/confirmation-modal.component';
import { TextChatMoreActionsComponent } from 'shared/components/work-widget-control-panel/text-chat-more-actions/text-chat-more-actions.component';
import { TextChatButtonsComponent } from './text-chat-buttons/text-chat-buttons.component';
import { ConfirmationModalConfig } from 'shared/components/confirmation-modal/confirmation-modal-config';
import { UserContextService } from 'common/user-context/user-context.service';
import { BcConfigService } from 'common/config/provider';
import { InnerTextPipe } from 'shared/components/canned-message-panel/filters/inner-text.pipe';
import { LogService } from 'common/logger/log.service';
import { LoggerService } from 'common/logger/logger.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'app-text-chat-box',
  templateUrl: './text-chat-box.component.html',
  styleUrls: ['./text-chat-box.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TextChatBoxComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

  @Input()
  public cannedMessageRequest: CannedMessageRequest;

  @Input()
  public isCannedMessagePanelOpen: boolean;

  @Input()
  public workItem: TextChatItem;

  @Input()
  public textChat: TextChat;

  @ViewChild('editorComponent')
  editorComponent: TinyMCEEditorComponent;

  @ViewChild(ConfirmationModalComponent)
  confirmationModalComponent: ConfirmationModalComponent;

  @ViewChild(TextChatButtonsComponent)
  textChatButtonsComponent: TextChatButtonsComponent;

  @ViewChild(TextChatMoreActionsComponent)
  textChatMoreActionsComponent: TextChatMoreActionsComponent;

  public confirmationBoxConfig: ConfirmationModalConfig = {
    title: 'bcTextChatBox.endConversationConfirmation.title',
    subtitle: 'bcTextChatBox.endConversationConfirmation.subtitle',
    buttonTitle: 'bcTextChatBox.endConversationConfirmation.yes',
    secondaryActionTitle: 'bcTextChatBox.endConversationConfirmation.endChatDontShowAgain',
    cancelTitle: 'bcTextChatBox.endConversationConfirmation.continue'
  };

  private oldValue;
  private _toggleSmartResponsesPanelSubscription;

  public KeyboardKeys;
  public hasSmartResponseFeature;
  public handleTypingKeyupThrottled;
  public operator;
  public setFocusOnEditorSubscription;
  public keyDownEventListener;
  public scrollToBottomTimeout;
  public isAttached;
  public editorCommandList;
  public isTyping;
  public typingTimeout;
  public messages;
  public visitor;
  public message;
  public initialMessage;
  public editorMessages;
  public editorDisabled;
  public isTransferPanelActive;
  public isSmartResponsesActive;
  public isWrapupPanelActive;
  public isMoreActionsVisible;

  public transferPanelScope;
  public scrollPane;
  public editorInstance;

  public textUser;
  public endChatTimeout;
  public unbindActiveChatWatcher;
  public welcomeMessageWasSetOnce: boolean;
  private readonly _isFileTransferForOperatorEnabledSubject = new BehaviorSubject<boolean>(false);

  public editorInitSetting;

  public areWrapupsLoaded: boolean = false;
  public wrapups: WrapUp[][] = [];

  public confirmationVisible: boolean = false;

  private _logger: LoggerService;

  constructor(private bcAnalytics: BcAnalytics,
              private bcAuth: BcAuth,
              public bcConfig: BcConfigService,
              private bcCannedMessagesRepo: BcCannedMessagesRepo,
              private bcSettingsService: BcSettingsService,
              private _userContextService: UserContextService,
              private bcRestApi: BcRestApi,
              private textChatMessagesStoreFactoryService: TextChatMessagesStoreFactoryService,
              private textChatUserStoreFactoryService: TextChatUserStoreFactoryService,
              private textChatMessagesService: TextChatMessagesService,
              private wrapupPanelService: WrapupPanelService,
              private textChatsService: TextChatsService,
              private WorkItemStateHandler: WorkItemStateHandler,
              private _translateService: TranslateService,
              private _workAreaManager: WorkAreaManager,
              public rxEmitter: RxEmitter,
              private element: ElementRef,
              private _changeDetector: ChangeDetectorRef,
              private _messageGroupService: MessageGroupService,
              private _closingConfirmationService: ClosingConfirmationService,
              private _innerTextPipe: InnerTextPipe,
              private _logService: LogService
  ) {
    this.KeyboardKeys = KeyboardKeyCodes;

    this.handleTypingKeyupThrottled = throttle(this.handleTypingKeyup, 800);

    this.operator = this.bcAuth.getSession();

    this.resetState();

    this.editorInitSetting = { plugins: 'autolink paste', toolbar: 'fileUpload', paste_as_text: true, formats: { underline: {}, bold: {}, italic: {} } };
    this._logger = this._logService.getLoggerInstance(TextChatBoxComponent.name);
  }

  get isFileTransferForOperatorEnabled$(): Observable<boolean> {
    return this._isFileTransferForOperatorEnabledSubject.asObservable();
  }

  ngOnInit() {
    if (this.textChat) {
      this.oldValue = this.textChat.isConversationActive(this.operator);
    }

    this.initCommandList();
    this.init();
    this._loadWrapups();
    this._hasSmartResponseFeature();

    this.setFocusOnEditorSubscription = this.rxEmitter.subscribe(`${MessageBusEvents.SetDefaultFocusInLane}${this.workItem.id}`, () => {
      this.setFocusOnMainElement();
    });

    this._toggleSmartResponsesPanelSubscription = this.rxEmitter.getNamespaceObservable(
      LaneManagerService.generateWorkItemObservableNamespace(MessageBusEvents.ToggleSmartResponses, this.workItem.id)
    ).subscribe(() => {
      this.toggleSmartResponsePanel();
    });

    this._hasFileTransferForOperatorEnabled();

    this.rxEmitter.subscribe(`${MessageBusEvents.SendCannedMessageToEditor}${this.workItem.id}`, data => {
      this._setLastSelectedCannedMessageIdForSendMessage(data);
    });
    this.rxEmitter.subscribe(`${MessageBusEvents.SendSmartResponseToEditor}${this.workItem.id}`, data => {
      this._setLastSelectedCannedMessageIdForSendMessage(data);
    });
  }

  ngOnChanges() {
    this.scrollPane = this.element.nativeElement.querySelector('.scroll-bottom-list');
    let newValue;
    if (this.textChat) {
      newValue = this.textChat.isConversationActive(this.operator);
      if (newValue !== this.oldValue && newValue === false) {
        if (!this.textChat.isClosed() && this.textChat.isEnded()) {
          this.isWrapupPanelActive = true;
        }
      }
    }
  }

  onEditorSubmit(editorContent): void {
    let message = this.preProcessMessage(editorContent);
    if (this.checkSlashCommand()) {
      message = '';
    }

    if (!this.isEmptyMessage(message)) {
      this.sendTyping(false);
      this.cancelIsTypingTimeout();

      const messageObj = {
        TextChatID: this.textChat.TextChatID,
        Name: this._userContextService.userContext.name,
        Text: message,
        CannedMessageID: this.textChat.CannedMessageID
      };

      this.textChatMessagesService.sendTextChatMessage(messageObj);
      this.clearEditor();
    }
  }

  private _setLastSelectedCannedMessageIdForSendMessage(data): void {
    if (data && (data.id || data.cannedMessageId)) {
      this.textChat.CannedMessageID = data.id || data.cannedMessageId;
    }
  }

  ngOnDestroy() {
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    if (this.endChatTimeout) {
      clearTimeout(this.endChatTimeout);
    }

    if (this.unbindActiveChatWatcher) {
      this.unbindActiveChatWatcher();
    }

    this.cancelScrollToBottomTimeout();

    this.setFocusOnEditorSubscription.unsubscribe();

    if (this._toggleSmartResponsesPanelSubscription) {
      this._toggleSmartResponsesPanelSubscription.unsubscribe();
    }

    this.element.nativeElement.removeEventListener('keydown', this.keyDownEventListener);
  }

  ngAfterViewInit() {
    this.keyDownEventListener = (e) => this.handleKeyDown(e);
    this.element.nativeElement.addEventListener('keydown', this.keyDownEventListener);

    this._changeDetector.detectChanges();
    this.isAttached = true;
    this.scrollToBottom();
  }

  onEditorSetupDone(editor): void {
    this.editorInstance = editor;

    this.editorInstance.on('keyUp', this.handleTypingOnKeyUp.bind(this));

    this.editorInstance.on('init', () => {
      if (this.isFocused()) {
        this.setFocusOnMainElement();
      }

      this.setWelcomeMessageIfNotAnsweredAndEditorIsEmpty();
      this._changeDetector.detectChanges();
      this.scrollToBottom();
    });

    this.editorInstance.settings.placeholder = this._translateService.instant('bcTextChatBox.editorPlaceholder');
  }

  handleTypingOnKeyUp(): void {
    if (!this.isTyping && this.editorInstance.getContent() !== '') {
      this.sendTyping(true);
      this.startIsTypingTimeout();
    } else if (this.isTyping) {
      this.cancelIsTypingTimeout();
      this.startIsTypingTimeout();
    }
  }

  init(): void {
    const textChatId = this.textChat.TextChatID;
    const textUserId = this.textChat.TextUserID;

    if (!this.isWrapupPanelActive && this.textChat.isEnded()) {
      this.isWrapupPanelActive = true;
    }

    this.textChatMessagesStoreFactoryService.create(textChatId).subscribe(messages => {
        this.setMessages(messages);
        this.scrollToBottomIfMessageReceived(messages);
      });

    this.textChatUserStoreFactoryService.create(textUserId).subscribe(user => {
        this.setUser(user);
      });
  }

  hasWrapUps(): boolean {
    return !!this.wrapups;
  }

  initCommandList(): void {
    this.editorCommandList = [
      { shortcut: slashCommands.CANNED_MESSAGES, description: 'bcTextChatBox.commands.cannedMessage' },
      { shortcut: slashCommands.ASSIGN, description: 'bcTextChatBox.commands.reassign' },
      { shortcut: slashCommands.END_CHAT, description: 'bcTextChatBox.commands.endChat' }
    ];
  }

  public onVisitorHistoryLoaded(): void {
    this.scrollPane = this.element.nativeElement.querySelector('.scroll-bottom-list');
    this.isAttached = true;
    this.scrollToBottom();
  }

  resetState(): void {
    if (this.isTyping) {
      this.sendTyping(false);
    }
    this.cancelIsTypingTimeout();
    this.isTyping = false;
    this.typingTimeout = null;

    this.messages = [];
    this.visitor = {};

    this.message = {
      text: ''
    };
    this.initialMessage = '';
    this.editorMessages = new EditorMessages();

    this.editorDisabled = false;
    this.isTransferPanelActive = false;
    this.isSmartResponsesActive = false;
    this.isWrapupPanelActive = false;
    this.isMoreActionsVisible = false;
  }

  setFocusOnMainElement(): void {
    // TODO: this is unmaintainable due to the number of cases - refactor this according to this ticket: https://jira.3amlabs.net/browse/BOLD-22884
    if (this.editorInstance && !this.editorDisabled && !this.isMoreActionsVisible) {
      if (this.editorInstance.initialized) {
        this.rxEmitter.send(broadcastEvents.focusEditor, null);
      } else {
        this.editorInstance.on('init', () => {
          this.rxEmitter.send(broadcastEvents.focusEditor, null);
        });
      }
    } else {
      this.element.nativeElement.focus();
    }
  }

  isFocused(): boolean {
    return this.WorkItemStateHandler.isFocused(this.workItem.id);
  }

  setWelcomeMessageIfNotAnsweredAndEditorIsEmpty(): void {
    if (!this._userContextService.userContext.operatorContext.textChatWelcomeMessageId) {
      return;
    }

    this.bcCannedMessagesRepo.getTextChatWelcomeCannedMessage(this.textChat.TextChatID)
      .then(welcomeMessage => {
        if (!welcomeMessage) {
          return;
        }

        if (!this.isOperatorAnswered() && this.isEditorEmpty()) {
          this.addCannedMessage(welcomeMessage);
          this.selectTextInEditor();
        }
      })
      .catch(() => {
        this._logger.logError('Cannot insert welcome message');
      });
  }

  isOperatorAnswered(): boolean {
    return this.messages.some(m => m.personId === this.operator.id);
  }

  isEditorEmpty(): boolean {
    return this.editorInstance && this.editorInstance.getContent() === '';
  }

  selectTextInEditor(): void {
    if (!this.editorInstance) {
      return;
    }

    setTimeout(() => {
      if (this.editorInstance.selection) {
        this.editorInstance.selection.select(this.editorInstance.getBody(), true);
      }
    });
  }

  isAnswerable(): boolean {
    return this.textChat && this.textChat.isAnswerable(this.operator);
  }

  isInProgress(): boolean {
    return !this.isAnswerable() && this.isTextChatActive() && !this.isWrapupPanelActive;
  }

  isUserTyping(): boolean {
    return this.textUser && this.textUser.IsTyping;
  }

  isEnded(): boolean {
    return this.textChat && this.textChat.isEnded();
  }

  isTextChatActive(): boolean {
    return this.textChat && this.textChat.isAnswered() && this.textChat.isAlive();
  }

  isEndable(): boolean {
    return this.textChat && this.textChat.isEndable();
  }

  public showConfirmation() {
    this.confirmationVisible = true;
  }

  public closeConfirmation() {
    this.confirmationVisible = false;
  }

  public endTextChatAndDontShowModal(): void {
    this._closingConfirmationService.setClosingConfirmation(this.workItem.type, true);
    this.rxEmitter.send(MessageBusEvents.ShowConfirmationPanelTooltip, null);
    this.endTextChat();
  }

  public endOrShowConfirmation(): void {
    if (this.isConfirmationModalDisabled()) {
      this.endTextChat();
    } else {
      this.showConfirmation();
    }
  }

  public isConfirmationModalDisabled(): boolean {
    return <boolean>(this._closingConfirmationService.getClosingConfirmationSetting(this.workItem.type));
  }

  endTextChat(): void {
    if (this.textChat) {
      this.closeConfirmation();
      this.textChatsService.endTextChat(this.textChat.TextChatID).then(() => {
        this.endChatTimeout = setTimeout(() => {
          if (!this.textChat.isClosed() && !this.isWrapupPanelActive) {
            this.toggleWrapupPanel();
          }
        }, 500);
      });
    }
  }

  openTransferTextChatSettings(): void {
    this.isTransferPanelActive = true;
    this.sendTransferPanelAnalytics(bcEnums.panelAction.OPEN);
  }

  closeTransferChatSettings(): void {
    if (this.isTransferPanelActive) {
      this.sendTransferPanelAnalytics(bcEnums.panelAction.CLOSE);
      this.isTransferPanelActive = false;
      this.transferPanelScope = null;
    }
  }

  answerTextChat(): void {
    if (this.textChat && this.isAnswerable()) {
      return this.textChatsService.answerTextChat(this.textChat.TextChatID)
        .then(() => {
          this.setWelcomeMessageIfNotAnsweredAndEditorIsEmpty();
        });
    }
  }

  setMessages(messages): void {
    this.getScrollPane();
    this.setIsAttachedToBottom();
    this.messages = this._messageGroupService.addNewMessagesToGroups(this.messages, messages, this.workItem.type);
    this.rxEmitter.send(LaneManagerService.generateWorkItemObservableNamespace(MessageBusEvents.SendWorkItemContent, this.workItem.id), this.messages);
    this._changeDetector.detectChanges();
  }

  setUser(users): void {
    this.textUser = users.length > 0 ? users[0] : null;
  }

  getScrollPane() {
    if (!this.scrollPane) {
      this.scrollPane = this.element.nativeElement.querySelector('.scroll-bottom-list');
    }
    return this.scrollPane;
  }

  setIsAttachedToBottom(): void {
    if (!this.scrollPane) {
      this.isAttached = true;
    } else {
      this.isAttached = this.scrollPane.scrollTop + this.scrollPane.clientHeight + 1 >= this.scrollPane.scrollHeight;
    }
  }

  scrollToBottomIfMessageReceived(messages): void {
    if (!messages.length) {
      return;
    }
    this._changeDetector.detectChanges();
    this.isAttached = true;
    this.scrollToBottom();
  }

  scrollToBottom(): void {
    if (this.scrollPane && this.isAttached) {
      this.scrollPane.scrollTop = this.scrollPane.scrollHeight;
    }
  }

  isEmptyMessage(message): boolean {
    return message.trim() === '';
  }

  removeMarkupNoise(message): string {
    return message.trim()
    // removing ending '&nbsp;'s '<br>'s, e.g. &nbsp;<br><br /></div> --> </div>
      .replace(/(\&nbsp;)*(<br\s*\/?>)+<\/div>$/g, '</div>')
      .replace(/\&nbsp;/g, ' ');
  }

  stripHtml(message): string {
    return message.trim().replace(/<[^>]+>/gm, '');
  }

  convertBreaksToNewLines(message): string {
    return message.replace(/<br\s?\/?>/gi, '\n');
  }

  decodeHtml(message): string {
    return this._innerTextPipe.transform(message);
  }

  preProcessMessage(message): string {
    const cleanedHtml = this.removeMarkupNoise(message);
    const newLines = this.convertBreaksToNewLines(cleanedHtml);
    const strippedHtml = this.stripHtml(newLines);
    const decoded = this.decodeHtml(strippedHtml);
    return decoded;
  }

  clearEditor(): void {
    this.editorInstance.setContent('');
  }

  checkSlashCommand(): boolean {
    const message = this.editorInstance.getContent({ format: 'text' });
    if (message.startsWith('/')) {
      this.executeCommand(message);
      return true;
    }
    return false;
  }

  executeCommand(command): void {
    this.bcAnalytics.eventTrack('SlashCommand', { type: 'textChat', command });
    switch (command) {
      case slashCommands.CANNED_MESSAGES:
        this.openCannedMessagePanel();
        break;
      case slashCommands.ASSIGN:
        this.openTransferTextChatSettings();
        break;
      case slashCommands.END_CHAT:
        this.sendTyping(false);
        this.endTextChat();
        break;
      case slashCommands.WRAP_UP:
        if (this.wrapups) {
          this.isWrapupPanelActive = true;
        } else {
          this.invalidCommand(command);
        }
        break;
      case slashCommands.CUSTOM_TAB:
        this.invalidCommand(command);
        break;
      default:
        this.invalidCommand(command);
    }
    this.clearEditor();
  }

  invalidCommand(command): void {
    this.bcAnalytics.eventTrack('InvalidCommand', { type: 'textChat', command });
    this.editorMessages.addEditorMessage('invalidCommand', 'bcTextChatBox.invalidCommand', { parsedCommand: command });
  }

  handleTypingKeyup(): void {
    if (!this.isTyping && this.message.text !== '') {
      this.sendTyping(true);
      this.startIsTypingTimeout();
    } else if (this.isTyping) {
      this.cancelIsTypingTimeout();
      this.startIsTypingTimeout();
    }
  }

  handleKeyDown(event): void {
    if (event.which === this.KeyboardKeys.ESC) {
      event.preventDefault();
      event.stopPropagation();

      this.closeCannedMessagePanel();
      this.closeTransferChatSettings();
      this.isWrapupPanelActive = false;
      setTimeout(() => {
        this.setFocusOnMainElement();
      });
    } else if ((event.metaKey || event.ctrlKey) && event.which === this.KeyboardKeys.SPACE) {
      event.preventDefault();
      event.stopPropagation();

      this.toggleSmartResponsePanel();
    }
  }

  /* SMART RESPONSE */

  toggleSmartResponsePanel(): void {
    this.initialMessage = this.message.text;
    this.isSmartResponsesActive = !this.isSmartResponsesActive;
    setTimeout(() => {
      if (this.isSmartResponsesActive) {
        this.rxEmitter.send(broadcastEvents.focusSmartResponses, null);
      } else {
        this.setFocusOnEditor();
      }
    });
  }

  closeSmartResponsePanel(): void {
    this.isSmartResponsesActive = false;
  }

  smartResponseSelected(smartResponse): void {
    if (smartResponse) {
      this.rxEmitter.send(`${MessageBusEvents.SendSmartResponseToEditor}${this.workItem.id}`, smartResponse);
    }
    this.setFocusOnEditor();
  }

  private _hasSmartResponseFeature(): void {
    this.bcSettingsService.getSettings().then(settings => {
      if (this.workItem.type === WorkItemTypes.FACEBOOK) {
        this.hasSmartResponseFeature = this.bcSettingsService.FacebookFeatures.isEnabled(settings, BcFeatures.FB_SMART_RESPONSE);
      } else if (this.workItem.type === WorkItemTypes.ASYNC_MESSAGE) {
        this.hasSmartResponseFeature = this.bcSettingsService.AsyncMessageFeatures.isEnabled(settings, BcFeatures.AM_SMART_RESPONSE);
      } else if (this.workItem.type === WorkItemTypes.SMS) {
        this.hasSmartResponseFeature = this.bcSettingsService.SmsFeatures.isEnabled(settings, BcFeatures.SM_SMART_RESPONSE);
      }
    });
  }

  private _hasFileTransferForOperatorEnabled() {
    this._isFileTransferForOperatorEnabledSubject.next(this.workItem.type === WorkItemTypes.ASYNC_MESSAGE);
  }

  /* /SMART RESPONSE */

  startIsTypingTimeout(): void {
    this.typingTimeout = setTimeout(() => {
      this.sendTyping(false);
    }, 3000, false);
  }

  cancelIsTypingTimeout(): void {
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
      this.typingTimeout = null;
    }
  }

  cancelScrollToBottomTimeout(): void {
    if (this.scrollToBottomTimeout) {
      clearTimeout(this.scrollToBottomTimeout);
      this.scrollToBottomTimeout = null;
    }
  }

  sendTyping(typing): void {
    if (this.textChat && (this.workItem && !this.workItem.isFacebook())) {
      this.bcRestApi.setTypingTextChat(this.textChat.TextChatID, typing);
      this.isTyping = typing;
    }
  }

  clearEditorMessage(): void {
    this.editorMessages.clearAllMessages();

    if (this.editorDisabled) {
      this.editorDisabled = false;
    }
  }

  addCannedMessage(cannedMessage): void {
    if (this.editorInstance) {
      this.editorInstance.insertContent(cannedMessage.text);
      this.textChat.CannedMessageID = cannedMessage.id;
    }
  }

  toggleCannedMessagePanel(): void {
    if (this.isCannedMessagePanelOpen) {
      this.closeCannedMessagePanel();
    } else {
      this.openCannedMessagePanel();
    }
  }

  openCannedMessagePanel(): void {
    this.sendCannedMessagePanelAnalytics(bcEnums.panelAction.OPEN);
    this.rxEmitter.send(`${MessageBusEvents.ActivateCannedMessagePanel}${this.workItem.id}`, null);
  }

  closeCannedMessagePanel(): void {
    this.sendCannedMessagePanelAnalytics(bcEnums.panelAction.CLOSE);
    this.rxEmitter.send(`${MessageBusEvents.CloseCannedMessagePanel}${this.workItem.id}`, null);
  }

  openCustomTab(): void {
    this.sendCannedMessagePanelAnalytics(bcEnums.panelAction.OPEN);
    this.rxEmitter.send(`${MessageBusEvents.ActivateCustomTabPanel}-${this.workItem.id}`, null);
  }

  toggleWrapupPanel(): void {
    this.isWrapupPanelActive = !this.isWrapupPanelActive;
    this.bcAnalytics.eventTrack('TextChatWrapupPanel', { action: this.isWrapupPanelActive ? bcEnums.panelAction.OPEN : bcEnums.panelAction.CLOSE });
    setTimeout(() => {
      if (!this.isWrapupPanelActive) {
        this.setFocusOnEditor();
      }
    });
  }

  toggleMoreActions(): void {
    // Before opening the panel, update the flag that indicates that the messages list is scrolled to the bottom.
    this.setIsAttachedToBottom();

    this.isMoreActionsVisible = !this.isMoreActionsVisible;

    setTimeout(() => {
      if (!this.isMoreActionsVisible) {
        this.setFocusOnEditor();
      }
    });

    // Wait for the open animation to complete, and then scroll the messages list to the bottom, if necessary.
    setTimeout(() => {
      this.scrollToBottom();
    }, 1000);
  }

  isExpandedMode(): boolean {
    return this._workAreaManager.isExpandedMode() || !this.workItem.isCollapsible;
  }

  setFocusOnEditor(): void {
    if (this.editorInstance) {
      this.rxEmitter.send(broadcastEvents.focusEditor, null);
    } else {
      this.element.nativeElement.focus();
    }
  }

  sendCannedMessagePanelAnalytics(property): void {
    let eventName;
    if (this.workItem.isFacebook()) {
      eventName = 'FacebookCMPanel';
    } else if (this.workItem.isAsyncMessage()) {
      eventName = 'AsyncMessageCMPanel';
    } else {
      eventName = 'SMSCMPanel';
    }
    this.bcAnalytics.eventTrack(eventName, { action: property });
  }

  sendTransferPanelAnalytics(property): void {
    let evenName;
    if (this.workItem.isFacebook()) {
      evenName = 'FacebookTransferPanel';
    } else if (this.workItem.isAsyncMessage()) {
      evenName = 'AsyncMessageTransferPanel';
    } else {
      evenName = 'SMSTransferPanel';
    }
    this.bcAnalytics.eventTrack(evenName, { action: property });
  }

  areWrapupsLoading(): boolean {
    return !this.areWrapupsLoaded && (this.isWrapupPanelActive || this.isEnded());
  }

  haveWrapupsLoaded(): boolean {
    return this.areWrapupsLoaded && (this.isWrapupPanelActive || this.isEnded());
  }

  _loadWrapups(): Promise<void> {
    return this.wrapupPanelService.getWrapUps(this.workItem.type, this.textChat.TextChatID)
      .then((wrapUps) => {
        this.wrapups = wrapUps;
        this.areWrapupsLoaded = true;
        if (this.wrapups) {
          this.editorCommandList.push({ shortcut: slashCommands.WRAP_UP, description: 'bcTextChatBox.commands.wrapUp' });
        }
      });
  }

  onWrapUpChange(wrapUpChanges: WrapUp[][]): void {
    this.wrapups = wrapUpChanges;
  }
}
